import React from 'react';
import { Link } from 'react-router-dom';

interface MarketplaceLogoProps {
  variant?: 'dark' | 'light';
  className?: string;
}

const MarketplaceLogo: React.FC<MarketplaceLogoProps> = ({ variant = 'dark', className = '' }) => {
  const src = `${import.meta.env.BASE_URL}ctvbuyer-logo.svg`;
  // Source SVG is white; invert it when rendering on light backgrounds
  const filter = variant === 'dark' ? 'brightness(0)' : 'none';
  return (
    <Link to="/" className={`inline-flex items-center shrink-0 ${className}`} aria-label="CTV Marketplace home">
      <img src={src} alt="CTV Marketplace" className="h-7 md:h-8 w-auto object-contain" style={{ filter }} />
    </Link>
  );
};

export default MarketplaceLogo;
